import { getSoftpointCredentials, PaymentSession } from "@/api/payment-session";
import { QueryOptionsWithoutKeyAndFn } from "@/types/types";
import { queryOptions, useQuery } from "@tanstack/react-query";

export function paymentCredentialsOptions(
	locationId: number,
	options?: QueryOptionsWithoutKeyAndFn<PaymentSession>,
) {
	return queryOptions({
		queryFn: () => getSoftpointCredentials(locationId),
		queryKey: ["payment-credentials", locationId],
		retry: false,
		refetchOnWindowFocus: true,
		staleTime: 0,
		...options,
	});
}

function useGetPaymentCredentials(
	locationId: number,
	options?: QueryOptionsWithoutKeyAndFn<PaymentSession>,
) {
	return useQuery(paymentCredentialsOptions(locationId, options));
}

export default useGetPaymentCredentials;
